import { useContext, useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'
import { ErrorsContext } from '../contexts/errors_context'
import { canonicalUrl } from '../lib/canonical_url'
import { applyDocumentMeta, defaultPageMeta } from '../lib/seo_meta'

const PageActions = () => {
  const location = useLocation()
  const { t } = useTranslation()
  const { resetErrors } = useContext(ErrorsContext)

  useLayoutEffect(() => {
    // Layout runs before route useEffects, including StrictMode's second
    // passive pass, so a page that already has its card replaces this title.
    // og:url stays on this path. CanonicalLink owns <link rel="canonical">.
    applyDocumentMeta({
      ...defaultPageMeta(),
      title: t('app.title'),
      url: canonicalUrl(location.pathname, location.search, window.location.origin) ?? null,
      type: 'website',
      imageUrl: null,
      priceAmount: null,
    })
    resetErrors?.()
  }, [location.pathname, location.search, resetErrors, t])

  return null
}

export { PageActions }
